module.exports = __webpack_public_path__ + "img/shape_landing_comofunciona_3.1e22a79b.svg";